export enum CategoriaGtm {
  ESTILO_DE_VIDA = 'Estilo de vida',
  MOVILIDAD = 'Movilidad',
  VIDA = 'Vida',
  SALUD = 'Salud',
  ARRENDAMIENTO = 'Hogar',
}
